export default __webpack_public_path__ + "b6d100d5c6568eeeaa3074cab6205b3f.svg";